module.exports = __webpack_public_path__ + "static/media/AI-手柄-屏幕-新.b86d8634.jpg";